import { render, staticRenderFns } from "./VTemplateOnlineApplication.vue?vue&type=template&id=5ec48a8c&lang=pug&v-cloak=true"
import script from "./VTemplateOnlineApplication.vue?vue&type=script&lang=ts"
export * from "./VTemplateOnlineApplication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RTemplateOnlineApplication.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FTemplate%2Fviews%2FOnlineApplication%2FVTemplateOnlineApplication.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports